import React, { useState, useContext, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Select, TimePicker } from 'antd';
import Input from '../../../../ui/Input';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { isEditStateContext, isSaveContext } from '../../../../../store/editableContext'
import { getData } from '../../apiCalls'
import Loader from '../../../../Loading'
import moment from 'moment';

declare global {
  interface Window {
    otherAmenitiesMiscellaneous: boolean;
    otherAmenitiesMiscellaneousBody: {
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      foodtakeaway: string, 
      ccaccessavail: string,
      ccaccesscost: string,  
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string
    },
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    }
  }
}

const Miscellaneous = () => {

  const [GuestLaundry, setGuestLaundry] = useState<string>('') 
  const [GuestLaundryFee, setGuestLaundryFee] = useState<string>('')
  const [GuestLaundryHours, setGuestLaundryHours] = useState<any>('')
  const [FrontDeskHours, setFrontDeskHours] = useState<any>('')
  const [FoodTakeAway, setFoodTakeAway] = useState<string>('')
  const [CreditCardAccessAvailability, setCreditCardAccessAvailability] = useState<string>('')
  const [CredtCardAccessCost, setCredtCardAccessCost] = useState<string>('')
  const [CreditCardAccessOnProperty, setCreditCardAccessOnProperty] = useState<string>('')
  const [CredtCardAccesNote, setCredtCardAccessNote] = useState<string>('')
  const [CribsAvailability, setCribsAvailability] = useState<string>('')
  const [CribsCost, setCribsCost] = useState<string>('')
  const [CribsOnProperty, setCribsOnProperty] = useState<string>('')
  const [CribsNotes, setCribsNotes] = useState<string>('')

  const [rateOptions] = useState<string[]>([
    'Available', 
    'Availiable at a Charge', 
    'Complimentary to All', 
    'Complimentary to Consortia Only', 
    'Cost not known or varies', 
    'Not Available', 
    'Subject to Availability'
  ])

  const [booleanValues] = useState<string[]>([
    'Yes', 
    'No'
  ]) 
  const [ready, setReady] = useState<boolean>(false)

  const [form] = Form.useForm();
  const { Option } = Select;

  const context = useContext(isEditStateContext)
  const saveContext = useContext(isSaveContext)

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const onCancelEdition = () => {
    return window.cancelEdition()
  }

  const saveAction = async () => {
    
    const guestLaundryIsString = () => {
      if(typeof GuestLaundryHours === 'object') {
        const tempGuestLaundry = GuestLaundryHours
        const startRange = moment(tempGuestLaundry[0]).format("HH:mm:ss")
        const endRange = moment(tempGuestLaundry[1]).format("HH:mm:ss")
        const resp = JSON.stringify(([startRange, endRange]))
        setGuestLaundryHours(resp)
        return resp
      }
      return GuestLaundryHours
    }
    const body = {
      "guestlaundry": GuestLaundry,
      "guestlaundryfee": GuestLaundryFee,
      "guestlaundryhours": guestLaundryIsString(),
      "foodtakeaway": FoodTakeAway,
      "ccaccessavail": CreditCardAccessAvailability,
      "ccaccesscost": CredtCardAccessCost,
      "ccaccessprop": CreditCardAccessOnProperty,
      "ccaccessnotes": CredtCardAccesNote,
      "cribavail": CribsAvailability,
      "cribcost": CribsCost,
      "cribprop": CribsOnProperty,
      "cribnotes": CribsNotes
    }
    window.otherAmenitiesMiscellaneousBody = body
  }

  const saveRange = (type: string, data: string[]) => {
    let startRange = ''
    let endRange = ''
    switch (type) {
      case 'guestLaundryHours':
        if (data && data[0]) {
          startRange = moment(data[0]).format("HH:mm:ss")
        }
        if (data && data[1]) {
          endRange = moment(data[1]).format("HH:mm:ss")
        }
        return setGuestLaundryHours(JSON.stringify([startRange, endRange]))
      default:
        return false
    }
  }

  const stringToJson = (ref: string) => {
    try {
      const data = JSON.parse(ref)
      if (data && data[0] !== '' && data[1] !== '') {
        return [moment(data[0], 'HH:mm:ss'),moment(data[1], 'HH:mm:ss')]
      }
      return ''
    } catch (error) {
      return ref
    }
  }

  useEffect(() => {
    const get = async () => {
      const response = await getData()
      const FrontDeskData = stringToJson(response.frontdeskhours)
      const guestLaundryData = stringToJson(response.guestlaundryhours)
      setGuestLaundry(response.guestlaundry)
      setGuestLaundryFee(response.guestlaundryfee)
      setGuestLaundryHours(guestLaundryData)
      setFrontDeskHours(FrontDeskData)
      setFoodTakeAway(response.foodtakeaway)
      setCreditCardAccessAvailability(response.ccaccessavail)
      setCredtCardAccessCost(response.ccaccesscost)
      setCreditCardAccessOnProperty(response.ccaccessprop)
      setCredtCardAccessNote(response.ccaccessnotes)
      setCribsAvailability(response.cribavail)
      setCribsCost(response.cribcost)
      setCribsOnProperty(response.cribprop)
      setCribsNotes(response.cribnotes)
      setReady(true)
    }
    get()
  },[])

  useEffect(() => {
    if (context) {
      // removing action buttons
      const buttons: any = document.getElementsByClassName('ligthButton')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.add('d-none')
      }
    }
  },[context])

  useEffect(() => {
    if (saveContext) {
      saveAction()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saveContext])

  useEffect(() => {
    function validation() {
      const onlyNumbers = /^[1-9]\d*$/
      const maxLength = /^(.){0,225}$/
        if (
        (onlyNumbers.test(GuestLaundryFee)
          || GuestLaundryFee === null
          || GuestLaundryFee === '')
        && (onlyNumbers.test(CredtCardAccessCost)
        || CredtCardAccessCost === null
        || CredtCardAccessCost === '')
        && (maxLength.test(CredtCardAccesNote)
          || CredtCardAccesNote === null
          || CredtCardAccesNote === '')
        && (onlyNumbers.test(CribsCost)
          || CribsCost === null
          || CribsCost === '')
        && (maxLength.test(CribsNotes)
          || CribsNotes === null
          || CribsNotes === '')
        ) {
          return window.otherAmenitiesMiscellaneous = true
        }
        return window.otherAmenitiesMiscellaneous = false
      }
      validation()
  }, [GuestLaundryFee, CredtCardAccessCost, CredtCardAccesNote, CribsCost, CribsNotes])

  return (
    <>
      {ready ?
        <PageContainer>
        <Grid container spacing={0} className="containerSpacing py-0">
          <Grid item xs={12} className="pb-0 px-0 my-0">
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                "GuestLaundry": GuestLaundry,
                "GuestLaundryFee": GuestLaundryFee,
                "GuestLaundryHours": GuestLaundryHours,
                "FoodTakeAway": FoodTakeAway,
                "CreditCardAccessAvailability": CreditCardAccessAvailability,
                "CredtCardAccessCost": CredtCardAccessCost,
                "CreditCardAccessOnProperty": CreditCardAccessOnProperty,
                "CredtCardAccesNote": CredtCardAccesNote,
                "CribsAvailability": CribsAvailability,
                "CribsCost": CribsCost,
                "CribsOnProperty": CribsOnProperty,
                "CribsNotes": CribsNotes
              }}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name='GuestLaundry'
                    label="Guest Laundry">
                    <Select allowClear onChange={(e: string) => setGuestLaundry(e)}
                      showSearch
                    >
                      {
                        booleanValues.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Guest Laundry Fee"
                    name="GuestLaundryFee"
                    rules={[{ pattern: /^[-+]?[0-9]*\.?[0-9]*$/, message: 'This field should be a number' }]}
                  >
                    <Input
                      onChange={(e: any) => setGuestLaundryFee(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Guest Laundry Hours"
                    name="GuestLaundryHours"
                  >
                    <TimePicker.RangePicker
                      format='HH:mm'
                      onChange={(e: any) => saveRange('guestLaundryHours', e)} 
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item
                    name='FoodTakeAway'
                    label="Food Take Away">
                    <Select allowClear onChange={(e: string) => setFoodTakeAway(e)}
                      showSearch
                    >
                      {
                        booleanValues.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                <Form.Item
                    name='CreditCardAccessAvailability'
                    label="Credit Card Access Availability">
                    <Select allowClear onChange={(e: string) => setCreditCardAccessAvailability(e)}
                      showSearch
                    >
                      {
                        rateOptions.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item
                    label="Credit Card Access Cost"
                    name="CredtCardAccessCost"
                    rules={[{ pattern: /^[-+]?[0-9]*\.?[0-9]*$/, message: 'This field should be a number' }]}
                  >
                    <Input
                      onChange={(e: any) => setCredtCardAccessCost(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item
                    name='CreditCardAccessOnProperty'
                    label="Credit Card Access On Property">
                    <Select allowClear onChange={(e: string) => setCreditCardAccessOnProperty(e)}
                      showSearch
                    >
                      {
                        booleanValues.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item
                    label="Credit Card Access Notes"
                    name="CredtCardAccesNote"
                    rules={[{ max: 225, message: 'You have reached the max character length of 225' }]}
                  >
                    <Input 
                      maxLength={225}
                      edit={context}
                      onChange={(e: any) => setCredtCardAccessNote(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                <Form.Item
                    name='CribsAvailability'
                    label="Cribs Availability">
                    <Select allowClear onChange={(e: string) => setCribsAvailability(e)}
                      showSearch
                    >
                      {
                        rateOptions.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                    </Form.Item>

                </Col>
                <Col span={6}>
                <Form.Item
                    label="Cribs Cost"
                    name="CribsCost"
                    rules={[{ pattern: /^[-+]?[0-9]*\.?[0-9]*$/, message: 'This field should be a number' }]}
                  >
                    <Input
                      onChange={(e: any) => setCribsCost(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                <Form.Item
                    name='CribsOnProperty'
                    label="Cribs On Property">
                    <Select allowClear onChange={(e: string) => setCribsOnProperty(e)}
                      showSearch
                    >
                      {
                        booleanValues.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Cribs Notes"
                    name="CribsNotes"
                    rules={[{ max: 225, message: 'You have reached the max character length of 225' }]}
                  >
                    <Input 
                      maxLength={225}
                      edit={context}
                      onChange={(e: any) => setCribsNotes(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
    </PageContainer>
    : <Loader type="medium" />}
    </>
  )
}

export default Miscellaneous
